import Speech  from 'speak-tts'

const speech = new Speech() // 创建语音播报实例
speech.setLanguage('zh-CN') // 设置语言
speech.init().then(() => {}) // 初始化

export const turnonSpeech = (text:string) => {
    // @ts-ignore
    speech.speak({
        text
    }).then(() => {
        console.log('播报成功')
    })
}